module.exports = __webpack_public_path__ + "static/media/2-Spades.bc7efbc3.svg";